import { useCallback, useEffect, useRef, useState } from "react";

const MIN_REFRESH_ANIMATION_MS = 650;

// Actualisation de la liste : ignore les doubles demandes et garde l'animation au moins 650 ms.
export function useCommandeListRefresh(onRefresh) {
    const [isRefreshing, setIsRefreshing] = useState(false);
    const refreshTimerRef = useRef(null);
    const refreshMountedRef = useRef(true);

    useEffect(() => {
        refreshMountedRef.current = true;
        return () => {
            refreshMountedRef.current = false;
            if (refreshTimerRef.current) clearTimeout(refreshTimerRef.current);
        };
    }, []);

    const handleRefresh = useCallback(() => {
        if (isRefreshing) return;
        const startedAt = Date.now();
        setIsRefreshing(true);
        Promise.resolve(onRefresh?.())
            .catch(() => {})
            .finally(() => {
                if (!refreshMountedRef.current) return;
                const remainingDuration = Math.max(MIN_REFRESH_ANIMATION_MS - (Date.now() - startedAt), 0);
                refreshTimerRef.current = setTimeout(() => {
                    setIsRefreshing(false);
                    refreshTimerRef.current = null;
                }, remainingDuration);
            });
    }, [isRefreshing, onRefresh]);

    return { isRefreshing, handleRefresh };
}
